import { LAYOUTS, } from '@voltmoney/types';
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconAlignmentTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackJustifyContent, StackType, StackWidth, TextAlignTokens, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../../routes';
import { ACTION } from './types';
import { GoBackAction, navigateCoBorrowerPan, verifyKycSummary, } from './actions';
import { heightMap } from '../../../../configs/height';
export const template = name => ({
    layout: {
        id: ROUTE.CO_BORROWER_SUMMARY_CONFIRM,
        type: LAYOUTS.MODAL,
        style: {
            height: heightMap[ROUTE.CO_BORROWER_SUMMARY_CONFIRM],
        },
        widgets: [
            { id: 'space1', type: WIDGET.SPACE },
            { id: 'iconStack', type: WIDGET.STACK },
            { id: 'space2', type: WIDGET.SPACE },
            { id: 'title', type: WIDGET.TEXT },
            { id: 'space3', type: WIDGET.SPACE },
            { id: 'subTitle', type: WIDGET.TEXT },
            { id: 'space4', type: WIDGET.SPACE },
            { id: 'continue', type: WIDGET.BUTTON },
            { id: 'space5', type: WIDGET.SPACE },
            { id: 'secondaryCTA', type: WIDGET.BUTTON },
            { id: 'space6', type: WIDGET.SPACE },
        ],
    },
    datastore: {
        space1: { size: SizeTypeTokens.MD },
        iconStack: {
            type: StackType.row,
            justifyContent: StackJustifyContent.center,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [{ id: 'successIcon', type: WIDGET.ICON }],
        },
        successIcon: {
            name: IconTokens.Success,
            size: IconSizeTokens.Size52,
            align: IconAlignmentTokens.center,
        },
        space2: { size: SizeTypeTokens.XL },
        title: {
            label: 'Verification successful',
            fontSize: FontSizeTokens.XL,
            color: ColorTokens.Grey_Night,
            fontFamily: FontFamilyTokens.Poppins,
            textAlign: TextAlignTokens.center,
            fontWeight: '600',
            lineHeight: 28,
        },
        space3: { size: SizeTypeTokens.SM },
        subTitle: {
            label: `Joint holder name: ${name}`,
            fontSize: FontSizeTokens.SM,
            color: ColorTokens.Grey_Charcoal,
            fontFamily: FontFamilyTokens.Inter,
            textAlign: TextAlignTokens.center,
            fontWeight: '400',
            lineHeight: 24,
        },
        space4: { size: SizeTypeTokens.XXXL },
        continue: {
            label: 'Continue',
            type: ButtonTypeTokens.LargeFilled,
            width: ButtonWidthTypeToken.FULL,
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.MD,
            lineHeight: SizeTypeTokens.XXL,
            fontWeight: '700',
            action: {
                type: ACTION.NAVIGATION_NEXT,
                routeId: ROUTE.CO_BORROWER_SUMMARY_CONFIRM,
                payload: {},
            },
        },
        space5: { size: SizeTypeTokens.LG },
        secondaryCTA: {
            label: 'Add another joint holder',
            type: ButtonTypeTokens.LargeSoftFilled,
            width: ButtonWidthTypeToken.FULL,
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.MD,
            lineHeight: SizeTypeTokens.XXL,
            fontWeight: '700',
            action: {
                type: ACTION.NAVIGATION_CO_BORROWER_PAN,
                routeId: ROUTE.CO_BORROWER_SUMMARY_CONFIRM,
                payload: {},
            },
        },
        space6: { size: SizeTypeTokens.XL },
    },
});
export const coBorrowerKYCSummaryConfirmMf = {
    onLoad: async (_, { name, network }) => {
        return Promise.resolve(template(name));
    },
    actions: {
        [ACTION.NAVIGATION_CO_BORROWER_PAN]: navigateCoBorrowerPan,
        [ACTION.NAVIGATION_NEXT]: verifyKycSummary,
        [ACTION.GO_BACK]: GoBackAction,
    },
};
